import StockLedger from "@/pages/inventory/StockLedger";
export default function RawStock() {
  return (
    <StockLedger
      title="Raw material stock"
      subtitle="Purchased goods — clay, glaze, frit, pigments, packing material."
      ownerLabel="Store Manager"
      filterTypes={["RAW", "PACKING", "CONSUMABLE"]}
      testid="raw-stock-page"
    />
  );
}
